if (!customElements.get('product-addons')) {
  customElements.define(
    'product-addons',
    class ProductAddons extends HTMLElement {
      constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
      }

      connectedCallback() {
        this.addEventListener('change', this.handleChange);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      handleVariantChange({ data }) {
        if (!data || !data.html || data.sectionId !== this.dataset.section) return;
        if (!this.id) return;

        const incoming = data.html.getElementById(this.id);
        if (!incoming) return;

        // The add-on list is variant-scoped, so the incoming set can differ from the
        // current one. Carry the customer's choices across by add-on product rather
        // than by position, and drop anything the new variant no longer offers.
        const selections = this.getSelections();

        this.innerHTML = incoming.innerHTML;
        this.classList.toggle('hidden', incoming.classList.contains('hidden'));

        this.restoreSelections(selections);
      }

      getSelections() {
        const selections = new Map();
        this.querySelectorAll('[data-addon-item]').forEach((item) => {
          const productId = item.dataset.addonProductId;
          if (!productId) return;

          const checkbox = item.querySelector('[data-addon-checkbox]');
          const select = item.querySelector('[data-addon-variant-select]');
          if (!checkbox?.checked) return;

          selections.set(productId, { variantId: select?.value || null });
        });
        return selections;
      }

      restoreSelections(selections) {
        if (selections.size === 0) return;

        this.querySelectorAll('[data-addon-item]').forEach((item) => {
          const saved = selections.get(item.dataset.addonProductId);
          if (!saved) return;

          const checkbox = item.querySelector('[data-addon-checkbox]');
          if (!checkbox || checkbox.disabled) return;

          // Only re-select a variant the new markup still offers as purchasable —
          // otherwise leave the server-rendered default and its price alone.
          const select = item.querySelector('[data-addon-variant-select]');
          if (select?.tagName === 'SELECT' && saved.variantId) {
            const stillOffered = Array.from(select.options).some(
              (option) => option.value === saved.variantId && !option.disabled
            );
            if (stillOffered) {
              select.value = saved.variantId;
              this.updatePrice(select);
            }
          }

          checkbox.checked = true;
        });
      }

      handleChange(event) {
        const select = event.target.closest('[data-addon-variant-select]');
        if (!select) return;

        this.updatePrice(select);
      }

      updatePrice(select) {
        const priceTargetSelector = select.dataset.priceTarget;
        if (!priceTargetSelector) return;
        const priceEl = this.querySelector(priceTargetSelector);
        if (!priceEl) return;

        const selectedOption = select.options ? select.options[select.selectedIndex] : null;
        const price = selectedOption?.dataset.price;
        if (price) priceEl.innerHTML = price;
      }

      getSelectedItems() {
        const items = [];
        this.querySelectorAll('[data-addon-item]').forEach((item) => {
          const checkbox = item.querySelector('[data-addon-checkbox]');
          if (!checkbox || !checkbox.checked || checkbox.disabled) return;

          const select = item.querySelector('[data-addon-variant-select]');
          if (!select) return;

          let variantId;
          if (select.tagName === 'SELECT') {
            const option = select.options[select.selectedIndex];
            if (!option || option.disabled) return;
            variantId = option.value;
          } else {
            variantId = select.value;
          }

          if (!variantId) return;
          items.push({ id: Number(variantId), quantity: 1 });
        });
        return items;
      }
    }
  );
}
